<fui-icon [height]="12" [icon]="'exclamation'" [width]="2"></fui-icon>
<fui-validation-pop [popped]="popped"
                    [parentVerticalAlignment]="verticalAlignment"
                    *ngIf="control?.errors?.['validationMessages'] || control?.errors?.['required']">
    <div *ngFor="let validationMessage of control?.errors?.['validationMessages']">
        {{validationMessage?.messageKey | translate: validationMessage?.['messageParams']}}
    </div>
    <div *ngIf="control?.errors?.['required']">
        {{'validation.common.required' | translate}}
    </div>
</fui-validation-pop>
